export default "__VITE_ASSET__3eab4e8e__"